// extracted by mini-css-extract-plugin
export var contactForm = "contact-form-module--contactForm--2gwX-";
export var error = "contact-form-module--error--2-xMR";
export var row = "contact-form-module--row--15jBz";
export var inputContainer = "contact-form-module--inputContainer--3vyqS";
export var inputLabel = "contact-form-module--inputLabel--_RMy5";
export var submitButton = "contact-form-module--submitButton--7-uNT";
export var submitBorders = "contact-form-module--submitBorders--3nnnN";
export var submitButtonInner = "contact-form-module--submitButtonInner--34T2w";
export var finePrint = "contact-form-module--fine-print--3KlW9";
export var successMessage = "contact-form-module--successMessage--36ep0";